import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CssdComponent} from './cssd.component';

const routes: Routes = [
    {
        path: 'cssd', component: CssdComponent
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/cssd/cssd.routing.ts